define('drops/modalAction/ModalActionSpa',[
    'jquery',
    'lq',
    'when',
    'drops/action/action',
    'lq/navigatorSpa',
    'lq/validatorGateway',
    'lq/actionLoader',
    'lq/layouting',
    'lq/responsive',
    'lq/highlighter'
], function ($, lq, when, Action, NavigatorSpa, validatorGateway, ActionLoader, layouting, responsive, highlighter) {
    'use strict';

    var ModalActionSpa = function (modalAction) {
        this.modalAction = modalAction;
        this.onActionLoaded = this.showAction.bind(this);
        this.onEventReceived = this.receiveEvent.bind(this);
    };

    ModalActionSpa.prototype.setUp = function () {
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.modalAction.$element)
            .css({
                width: '100%',
                height: '100%',
                border: 0,
                display: 'none'
            });
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);
        this.$modals = $('<div />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.modalAction.piping.$app);

        if(!validatorGateway.isEnabled()) {
            var self = this;
            this.gatewayCallback = function() {
                if (!self.action) return;
                self.informValidator(self.action);
            };
            validatorGateway.whenEnabled(this.gatewayCallback);
        }
    };

    ModalActionSpa.prototype.show = function (actionId) {
        if (!actionId) return;

        var globals = this.modalAction.piping.parameters.globals.getAll();
        var locals = this.modalAction.getParametersForIframe();

        this.navigator = NavigatorSpa.inMemory(actionId, this.modalAction.piping.url, this.openNewAction.bind(this));
        this.actionLoader = new ActionLoader(this.modalAction.piping.url);
        this.actionLoader.addListener(this.onActionLoaded);

        this.openNewAction(actionId, globals, locals);
    };

    ModalActionSpa.prototype.showAction = function (setup, parameters) {
        if (!this.defaultCss)
            this.defaultCss = this.modalAction.$element.attr('style');
        else {
            // reset the css
            this.modalAction.$element.attr('style', this.defaultCss);
        }

        this.$wrapper.css('display', 'inherit');
        this.$modals.css('display', 'inherit');

        if(setup.view.insertionPoint) {
            var index = this.insertionPoints.indexOf(setup.view.insertionPoint);
            this.insertionPoints = this.insertionPoints.slice(0, index + 1);
            this.insertionPoints = this.insertionPoints
                .concat(_.map(setup.view.actions, function(action) {
                    return action.action.id;
                }));

            this.action.setContent(setup.view.actions, parameters.locals, setup.view.insertionPoint);
        } else {
            if (setup.view.actions[0].action.view.data.makeItGrow) {
                this.$wrapper.css({
                    height: 'auto'
                });
            } else {
                this.$wrapper.css({
                    height: '100%'
                });
            }
            this.insertionPoints = _.map(setup.view.actions, function(action) {
                return action.action.id;
            });

            var actionData = setup.view.actions[0].action;
            var systemParameters = setup.view.actions[0].systemParameters;
            var localParameters = setup.view.actions.length > 1 ? {} : parameters.locals;

            var action = new Action(actionData.view, this.modalAction.piping.application.options);
            action.loadData(actionData);
            action.piping = this.modalAction.piping.createChildPiping(actionData, action, localParameters, systemParameters, this.$wrapper, this.$view, false);
            action.piping.runtime = this;
            action.piping.navigator = this.navigator;
            action.piping.$modals = this.$modals;
            action.globals = _.clone(parameters.globals);
            action.locals = _.clone(parameters.locals);

            if(this.modalAction.data.enableBackwardsCompatibility) {
                action.piping.eventing.addBeforeInterceptor(this.onEventReceived);
            } else {
                action.piping.eventing.addAfterInterceptor(this.onEventReceived);
            }

            var layout = responsive.getCurrentLayout(action);
            layouting.applyLayout(this.$view, layout);
            action.applyLayout(layout, true);

            if(this.action && document.startViewTransition) {
                var transition = document
                    .startViewTransition(() => {
                        var promise = this.startActionRender(action);
                        this.postActionRender(action, actionData, setup, parameters.locals);
                        return promise;
                    });
                transition.updateCallbackDone
                    .then(() => action.startEventing());
            } else {
                this.startActionRender(action, actionData)
                    .then(function() {
                        action.startEventing();
                    });
                this.postActionRender(action, actionData, setup, parameters.locals);
            }
        }

        this.action.piping.busyIndicator.forceHide();
    };

    ModalActionSpa.prototype.startActionRender = function (action) {
        return action.createAndRenderDrops($());
    };

    ModalActionSpa.prototype.postActionRender = function (action, actionData, setup, locals) {
        if(validatorGateway.isEnabled()) {
            this.informValidator(action);
        }

        var isTop = $.isNumeric(this.modalAction.data.top);
        var isBottom = $.isNumeric(this.modalAction.data.bottom);
        var isLeft = $.isNumeric(this.modalAction.data.left);
        var isRight = $.isNumeric(this.modalAction.data.right);

        if ((this.modalAction.$element.css('position') === 'relative'  || this.modalAction.data.renderInScrollContainer || this.modalAction.data.useSelectedActionSize) && !action.canGrow()) {
            this.modalAction.$element.height('100%');
            if (this.modalAction.data.useSelectedActionSize) {
                if (!action.canGrow()) {
                    var height = (action.data.top || 0) + action.data.size.y + (action.data.bottom || 0);
                    this.modalAction.$element.height(height);
                }

                var width = (action.data.left || 0) + action.data.size.x + (action.data.right || 0);
                this.modalAction.$element.width(width);
            }
        }
            if (this.modalAction.data.renderInScrollContainer) {
                this.modalAction.$element.css({
                    position: 'relative',
                    overflow: 'hidden'
                });
                if (isTop || isBottom || isLeft || isRight) { // if we have at least one anchor then we use padding instead of inset
                    this.modalAction.$element.css({
                        inset: ''
                    });
                }
                if (isTop && isBottom) {
                    this.modalAction.$element.css({
                        height: '100%',
                        boxSizing: 'border-box',
                    });
                } else {
                    this.modalAction.$element.css({
                        height: this.modalAction.data.useSelectedActionSize ? action.data.size.y: this.modalAction.data.size.y
                    });
                }
                if (isTop) {
                    this.modalAction.$scrollContainer.css({
                        paddingTop: this.modalAction.data.top + 'px'
                    });
                }
                if (isBottom) {
                    this.modalAction.$scrollContainer.css({
                        paddingBottom: this.modalAction.data.bottom + 'px'
                    });
                }
                if (isLeft) {
                    this.modalAction.$scrollContainer.css({
                        paddingLeft: this.modalAction.data.left + 'px'
                    });
                }
                if (isRight) {
                    this.modalAction.$scrollContainer.css({
                        paddingRight: this.modalAction.data.right + 'px'
                    });
                }
            }

        if ((action.canGrow() && this.modalAction.data.renderInScrollContainer) || (this.modalAction.$element.css('position') === 'relative' && action.canGrow())) {
            // padding comes into play // min-height width in a couple of cases
            this.modalAction.$element.css({
                position: 'relative',
                overflow: 'hidden',
                height: '',
                width: ''

            });

            if (isTop || isBottom || isLeft || isRight) { // if we have at least one anchor then we use padding instead of inset
                this.modalAction.$element.css({
                    inset: ''
                });
            }

            if ((!this.modalAction.parent || !this.modalAction.parent.data.isDynamiclySizedContainer) && !this.modalAction.data.useSelectedActionSize ) {
                this.modalAction.$element.css({
                    boxSizing: 'border-box'
                });
            }

            if (isTop && isBottom) {
                this.modalAction.$element.css({
                    minHeight:'100%',
                    top: '',
                    bottom: ''
                });
            } else if (!isTop && isBottom) {
                this.modalAction.$element.css({
                    minHeight:'100%',
                    top: '0px'
                });
            }

            if (isLeft && isRight) {
                this.modalAction.$element.css({
                    minWidth:'100%',
                    left: '',
                    right: ''
                });

                // we need this for horizontal scrollbar to appear
                if (!$.isNumeric(action.data.left) || !$.isNumeric(action.data.right)) {
                    this.modalAction.$element.css({
                        width: action.data.size.x
                    });
                }
            }
            else if (!isLeft && isRight) {
                this.modalAction.$element.css({
                    minWidth:'100%',
                    left: '0px'
                });
            }

            if (!isLeft || !isRight) {
                if (this.modalAction.data.useSelectedActionSize) {
                    this.modalAction.$element.css({
                        width:  action.data.size.x
                    });
                }
                else {
                    this.modalAction.$element.css({
                        width: this.modalAction.data.size.x
                    });
                }
            }

            if (this.modalAction.$scrollContainer) {
                if (isTop) {
                    this.modalAction.$scrollContainer.css({
                        paddingTop: this.modalAction.data.top + 'px'
                    });
                }

                if (isBottom) {
                    this.modalAction.$scrollContainer.css({
                        paddingBottom: this.modalAction.data.bottom + 'px'
                    });
                }

                if (isLeft) {
                    this.modalAction.$scrollContainer.css({
                        paddingLeft: this.modalAction.data.left + 'px'
                    });
                }

                if (isRight) {
                    this.modalAction.$scrollContainer.css({
                        paddingRight: this.modalAction.data.right + 'px'
                    });
                }
            }
        }

        this.cleanupCurrentAction();

        this.action = action;

        action.setContent(setup.view.actions.slice(1), locals);

        this.$wrapper.scrollTop(0);
    };

    ModalActionSpa.prototype.informValidator = function (action) {
        validatorGateway.registerListener(action.instanceId, this.receiveMessage.bind(this));

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_LOADED',
            action: action,
            parentInstanceId: this.modalAction.rootDrop.instanceId,
            canReload: true
        });
    };

    ModalActionSpa.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.openNewAction(this.action.data.id, this.action.globals, this.action.locals);
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    ModalActionSpa.prototype.openNewAction = function(actionId, globals, locals) {
        this.actionLoader.load(actionId, globals, locals, null, this.insertionPoints);
    };

    ModalActionSpa.prototype.hide = function () {
        if (!this.$wrapper) return;

        this.$wrapper.css('display', 'none');
        this.$modals.css('display', 'none');

        var self = this;
        function waitForTaskCompletion() {
            if (self.action && self.action.piping.busyIndicator.showCount !== 0) {
                setTimeout(waitForTaskCompletion, 100);
            } else {
                self.cleanupCurrentAction();
            }
        }

        waitForTaskCompletion();
    };

    ModalActionSpa.prototype.triggerEventForChild = function (eventObj) {
        if (!this.action) return;

        this.action.triggerEvent(eventObj.eventName, eventObj.args[0]);
    };

    ModalActionSpa.prototype.onError = function (errorArgs) {
        if (this.action)
            this.action.onError(errorArgs);
    };

    ModalActionSpa.prototype.receiveEvent = function (e) {
        if (!this.modalAction.data.eventsToCatch || this.modalAction.data.eventsToCatch.indexOf(e.eventName) === -1)
            return;

        var deferred = when.defer();

        var args = e.args ? e.args[0] : null;
        this.modalAction.piping.eventing.publish(
            this.modalAction.data.id + '.' + e.eventName,
            undefined,
            args,
            function () {
                deferred.resolve();
            },
            e.parentEventAction);

        return deferred.promise;
    };

    ModalActionSpa.prototype.cleanupCurrentAction = function() {
        if (!this.action) return;

        if(validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_UNLOADING',
                action: this.action
            });
        }

        this.action.piping.eventing.removeInterceptor(this.onEventReceived);
        this.action.piping.cleanUp();
        this.action.unsubscribeEventHandlersRecursive();

        if(validatorGateway.isEnabled()) {
            validatorGateway.unregisterListener(this.action.instanceId);
        }

        this.action = null;
    };

    ModalActionSpa.prototype.dispose = function () {
        this.cleanupCurrentAction();

        if (this.actionLoader) {
            this.actionLoader.removeListener(this.onActionLoaded);
            this.actionLoader = null;
        }

        if (this.gatewayCallback) {
            validatorGateway.removeCallback(this.gatewayCallback);
        }

        this.$modals.remove();
    };

    return ModalActionSpa;
});

